module.exports = __webpack_public_path__ + "static/media/natalias.1d8dbcfb.jpg";